import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cp-chart-of-accounts',
    templateUrl: './chart-of-accounts.component.html',
    styleUrls: ['./chart-of-accounts.component.scss'],
    standalone: false
})
export class ChartOfAccountsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
